module.exports = __webpack_public_path__ + "img/citySelect5.ac6bd29d.png";